"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pagediyDeleteApi = pagediyDeleteApi;
exports.pagediyGetSetHome = pagediyGetSetHome;
exports.pagediyInfoApi = pagediyInfoApi;
exports.pagediyListApi = pagediyListApi;
exports.pagediySaveApi = pagediySaveApi;
exports.pagediySetdefaultApi = pagediySetdefaultApi;
exports.pagediyUpdateApi = pagediyUpdateApi;
exports.wechatQrcodeApi = wechatQrcodeApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  列表
 */
function pagediyListApi(params) {
  return (0, _request.default)({
    url: '/admin/pagediy/list',
    method: 'get',
    params: params
  });
}
/**
 *  新增
 */
function pagediySaveApi(data) {
  return (0, _request.default)({
    url: '/admin/pagediy/save',
    method: 'post',
    data: data
  });
}
/**
 *  更新
 */
function pagediyUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/pagediy/update',
    method: 'post',
    data: data
  });
}
/**
 *详情
 */
function pagediyInfoApi(id) {
  return (0, _request.default)({
    url: "/admin/pagediy/info/".concat(id),
    method: 'get'
  });
}
/**
 *删除
 */
function pagediyDeleteApi(params) {
  return (0, _request.default)({
    url: "/admin/pagediy/delete",
    method: 'get',
    params: params
  });
}
/**
 *设为首页
 */
function pagediySetdefaultApi(id) {
  return (0, _request.default)({
    url: "/admin/pagediy/setdefault/".concat(id),
    method: 'get'
  });
}
/**
 *获取首页
 */
function pagediyGetSetHome(id) {
  return (0, _request.default)({
    url: "/admin/pagediy/getdefault",
    method: 'get'
  });
}
/**
 * 获取小程序二维码
 * @returns {*}
 */
function wechatQrcodeApi(data) {
  return (0, _request.default)({
    url: "/public/wechat/mini/get/qrcode",
    method: 'post',
    data: data
  });
}